import React, { useState } from "react";
import { updateMatchResult } from "services/matchService";
import * as Sentry from "@sentry/react";

const RandomScoreGenerator = ({ tournament, matches, onScoresGenerated }) => {
  const [loading, setLoading] = useState(false);

  const generateRandomScores = async () => {
    if (!tournament?.id || !matches?.length) {
      alert("❌ Aucun tournoi ou match trouvé.");
      return;
    }

    if (tournament?.compiled) {
      alert("❌ Ce tournoi a déjà été compilé. Impossible de modifier les scores.");
      return;
    }

    const confirmed = window.confirm(
      "⚠️ ATTENTION: Ceci va générer des scores aléatoires (0-1 ou 1-0) pour TOUS les matchs de qualification sans score. Continuer ?"
    );

    if (!confirmed) return;

    setLoading(true);

    console.log(matches);

    try {
      // Filter qualification matches without results
      const qualificationMatches = matches.filter(
        (match) =>
          (match.phase === "group" || match.phase === "crosspool") &&
          !match.result
      );

      if (qualificationMatches.length === 0) {
        alert("ℹ️ Aucun match de qualification sans score trouvé.");
        setLoading(false);
        return;
      }

      console.log(`Génération de scores pour ${qualificationMatches.length} matchs...`);

      // Generate random scores for each match
      const updatePromises = qualificationMatches.map(async (match) => {
        // Random score: either 1-0 or 0-1
        const randomResult = Math.random() < 0.5
          ? { team1: 1, team2: 0 }
          : { team1: 0, team2: 1 };

        try {
          await updateMatchResult(match.id, randomResult);
          console.log(`Score généré pour match ${match.id}: ${randomResult.team1}-${randomResult.team2}`);
          return { success: true, matchId: match.id };
        } catch (error) {
          console.error(`Erreur pour match ${match.id}:`, error);
          return { success: false, matchId: match.id, error };
        }
      });

      const results = await Promise.allSettled(updatePromises);

      const successful = results.filter(r => r.status === "fulfilled" && r.value.success).length;
      const failed = results.length - successful;

      if (failed > 0) {
        alert(`⚠️ ${successful} scores générés avec succès, ${failed} échecs.`);
      } else {
        alert(`✅ ${successful} scores aléatoires générés avec succès !`);
      }

      // Trigger parent component refresh
      onScoresGenerated?.();

    } catch (error) {
      Sentry.captureException(error);
      console.error("Erreur lors de la génération des scores :", error);
      alert("❌ Erreur lors de la génération des scores.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-orange-600 border-2 border-orange-700 rounded-lg p-4 shadow-xl">
      <h4 className="text-white font-bold mb-2">🎲 Générateur de Scores Aléatoires</h4>
      <p className="text-orange-100 text-sm mb-3">
        ⚠️ TEMPORAIRE: Génère des scores aléatoires (0-1 ou 1-0) pour tous les matchs de qualification.
      </p>
      <button
        onClick={generateRandomScores}
        disabled={loading || tournament?.compiled}
        className={`px-4 py-2 rounded font-bold text-white transition ${
          loading || tournament?.compiled
            ? "bg-neutral-500 cursor-not-allowed"
            : "bg-red-600 hover:bg-red-700"
        }`}
      >
        {loading ? "Génération en cours..." : "Générer Scores Aléatoires"}
      </button>
      {tournament?.compiled && (
        <p className="text-orange-200 text-xs mt-2">
          Tournoi compilé - génération impossible
        </p>
      )}
    </div>
  );
};

export default RandomScoreGenerator;